import { useAppSelector } from '@/redux/hooks/useAppSelector';
import { deserializeDate } from '@/utils/time/deserializeDate';
import {
  minervaBuildDateSelector,
  minervaGitHashSelector,
  minervaVersionSelector,
} from '@/redux/configuration/configuration.selectors';

const DATE_PART_LENGTH = 2;
const FIRST_MONTH_INDEX = 1;

const padDatePart = (value: number): string => String(value).padStart(DATE_PART_LENGTH, '0');

const formatBuildDate = (buildDate: string | undefined): string | undefined => {
  if (!buildDate) {
    return undefined;
  }

  const date = deserializeDate(buildDate);

  if (Number.isNaN(date.getTime())) {
    return buildDate;
  }

  const day = padDatePart(date.getDate());
  const month = padDatePart(date.getMonth() + FIRST_MONTH_INDEX);
  const time = `${padDatePart(date.getHours())}:${padDatePart(date.getMinutes())}`;

  return `${date.getFullYear()}-${month}-${day} ${time}`;
};

export const MinervaVersionInfo = (): JSX.Element | null => {
  const version = useAppSelector(minervaVersionSelector);
  const gitHash = useAppSelector(minervaGitHashSelector);
  const buildDate = useAppSelector(minervaBuildDateSelector);

  if (!version) {
    return null;
  }

  const formattedBuildDate = formatBuildDate(buildDate);

  return (
    <span
      className="truncate text-sm text-muted-foreground"
      title={gitHash ? `Git hash: ${gitHash}` : undefined}
    >
      The MINERVA Platform v{version}
      {formattedBuildDate ? ` build ${formattedBuildDate}` : ''}
    </span>
  );
};
